/** Colors the Dashboard's last-synced indicator based on admin-configured age thresholds. */

export const DEFAULT_SYNC_FRESH_DAYS = 7
export const DEFAULT_SYNC_STALE_DAYS = 30

export type SyncFreshnessColor = 'success' | 'warning' | 'danger'

export function syncFreshnessColor(
  lastSyncedAt: string | null,
  freshDays = DEFAULT_SYNC_FRESH_DAYS,
  staleDays = DEFAULT_SYNC_STALE_DAYS,
): SyncFreshnessColor {
  if (!lastSyncedAt) return 'danger'
  // lastSyncedAt is a Kyiv wall-clock string with no timezone designator (nowKyiv()), so this
  // parses it as the browser's local time — off by whatever the Kyiv/browser tz gap is, at most
  // a few hours, which doesn't matter at day-granularity freshness thresholds.
  const ageDays = (Date.now() - new Date(lastSyncedAt).getTime()) / (1000 * 60 * 60 * 24)
  if (ageDays <= freshDays) return 'success'
  if (ageDays <= staleDays) return 'warning'
  return 'danger'
}

/** Plain-language relative time for the Dashboard's last-synced column */
export function formatSyncAge(lastSyncedAt: string | null): string {
  if (!lastSyncedAt) return 'Never synced'
  const ageMs = Date.now() - new Date(lastSyncedAt).getTime()
  const ageDays = Math.floor(ageMs / (1000 * 60 * 60 * 24))
  if (ageDays <= 0) return 'Today'
  if (ageDays === 1) return '1 day ago'
  return `${ageDays} days ago`
}
